import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Popup from '../../common/Popup';
import Button from '../../Button';
import { supportInfoSelector } from '../../../redux/context/selectors';
import styles from './index.styl';

const DeleteAccount = ({ intl: { formatMessage } }) => {
  const [open, setOpen] = useState(false);
  const { email, phoneNumber } = useSelector(supportInfoSelector);

  return (
    <section>
      <div className={styles.deleteAccount} onClick={() => setOpen(true)}>
        {formatMessage({ id: 'profile.section.deleteAccount.title' })}
      </div>

      {open && (
        <Popup
          opened={open}
          onClose={() => setOpen(false)}
          withHeading={false}
          mobileFullScreen={false}
        >
          <div className={styles.modalWrapper}>
            <h1 className={styles.modalTitle}>
              {formatMessage({ id: 'profile.section.deleteAccount.title' })}
            </h1>

            <div className={styles.description}>
              {formatMessage({
                id: 'profile.section.deleteAccount.description',
              })}
            </div>

            <div className={styles.field}>
              <p className={styles.title}>
                {formatMessage({
                  id: 'fields.phoneNumber',
                })}
              </p>
              <p className={styles.content}>{phoneNumber}</p>
            </div>

            <div className={styles.field}>
              <p className={styles.title}>
                {formatMessage({
                  id: 'fields.email',
                })}
              </p>
              <p className={styles.content}>{email}</p>
            </div>

            <Button color="primary" onClick={() => setOpen(false)}>
              {formatMessage({ id: 'common.ok' })}
            </Button>
          </div>
        </Popup>
      )}
    </section>
  );
};

DeleteAccount.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(DeleteAccount);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/DeleteAccount/index.jsx